/**
 * Create the store with asynchronously loaded reducers
 */


import {applyMiddleware, compose, createStore} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import createReducer from './reducers';
import promiseMiddleware from 'redux-promise-middleware';
import {loadingBarMiddleware} from 'react-redux-loading-bar';
import {load, save} from 'redux-localstorage-simple';


export default function configureStore(initialState = {}, history) {
    // Create the store with two middlewares
    // 1. sagaMiddleware: Makes redux-sagas work
    // 2. routerMiddleware: Syncs the location/URL path to the state
    const middlewares = [
        routerMiddleware(history),
        promiseMiddleware(),
        loadingBarMiddleware({
            promiseTypeSuffixes: ['PENDING', 'FULFILLED', 'REJECTED']
        }),
        save({ states: ['cfg', 'cart'] })
    ];


    const enhancers = [applyMiddleware(...middlewares)];

    if (process.env.NODE_ENV !== 'production') {
        const devtools = window.devToolsExtension || (() => noop => noop);
        enhancers.push(devtools());
    }

    const store = createStore(
        createReducer(),
        load({ states: ['cfg', 'cart'] }),
        compose(...enhancers)
    );


    // Make reducers hot reloadable, see http://mxs.is/googmo
    /* istanbul ignore next */
    if (module.hot) {
        import('./reducers').then(reducerModule => {
            const createReducers = reducerModule.default;
            const nextReducers = createReducers(store.asyncReducers);
            store.replaceReducer(nextReducers);
        });
    }

    // Initialize it with no other reducers
    store.asyncReducers = {};
    return store;
}
